<template>
  <div class="footer-page-wrapper">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pager[pageNoName]"
      :page-sizes="pageSizes"
      :page-size="pager[pageSizeName]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pager[totalName]">
    </el-pagination>
  </div>
</template>
<script>
  export default {
    name: 'GcVsPagination',
    props:{
      pager:{
        type: Object,
        defalut: () =>{
          return {
            page: 1,
            size: 20,
            total: 0
          }
        }
      },
      pageNoName:{
        type: String,
        default: 'page'
      },
      pageSizeName:{
        type: String,
        default: 'size'
      },
      totalName:{
        type: String,
        default: 'total'
      },
      pageSizes:{
        type: Array,
        default: () =>{
          return [5,10,20,50,100,200,500];
        }
      }
    },
    data: () => ({
      
    }),
    computed: {
    
    },
    watch: {
    
    },

    async mounted () {
    
    },

    methods:{
      //更改每页条数
      handleSizeChange(val){
        this.$emit('handleSizeChange',val);
      },
      handleCurrentChange(val){
        this.$emit('handleCurrentChange',val);
      }
    }
  }
</script>
<style lang="scss" scoped>
  //分页样式
  .footer-page-wrapper{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
  }
</style>
